import React from "react";


const CurrencyFormatter = (props)  => {
    if(props.price == null){
        return "€" + 0
    }
    else{
        let value = (props.price.cents / 100)
        return "€" +  value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
};

export default CurrencyFormatter;